<template>
    <div>
        <div class="support-hero tw-mb-12">
            <div class="bg-img"></div>
            <div class="hero-content flex tw-h-full relative">
                <div class="flex-1 tw-flex tw-flex-col normal-text">
                    <h1 class="dark-text" v-text="translations['navigation.support']"></h1>
                    <h2 class="tw-flex-1" v-if="categories_loaded">
                        <template v-if="support_options_count >= 1">
                            {{ translations['support.support_intro'] }}
                        </template>
                        <template v-else-if="support_options_count < 1 && !support_not_enabled">
                            {{ translations['support.no_access'] }}
                        </template>
                        <template v-else-if="support_not_enabled">
                            {{ translations['support.not_enabled'] }}
                        </template>
                    </h2>
                    <div class="tw-flex" v-if="support_options_count >= 1">
                        <div class="support-nav-option" v-if="faq_available"
                            :class="{ 'secondary-c': active_support_tab === 'faq' }" @click="setTabTo('faq')">
                            <i class="fal fa-question-circle"></i>
                            <h3 v-text="translations['support.faq_full']"></h3>
                        </div>
                        <div class="support-nav-option" v-if="helpdesk_available"
                            :class="{ 'secondary-c': active_support_tab === 'helpdesk' }" @click="setTabTo('helpdesk')">
                            <i class="fal fa-paper-plane"></i>
                            <h3 v-text="translations['navigation.helpdesk_tickets']"></h3>
                        </div>
                        <div class="support-nav-option" v-if="contact_available"
                            :class="{ 'secondary-c': active_support_tab === 'contact' }" @click="setTabTo('contact')">
                            <i class="fal fa-envelope"></i>
                            <h3 v-text="translations['navigation.contact']"></h3>
                        </div>
                    </div>
                </div>
                <svg class="tw-pointer-events-none" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 464.75 387.29"
                    style="enable-background:new 0 0 464.75 387.29;" xml:space="preserve">
                    <g class="st0">
                        <g>
                            <path class="st1" d="M426.15,328.54c20.11,0,32.28-20.59,20.46-35.25c-0.25-0.31-0.51-0.61-0.77-0.91
			c-7.23-8.19-18.19-11.13-27.91-15.7c-2.68-1.26-5.38-2.74-7.26-5.11c-2.61-3.31-3.24-7.93-2.7-12.19
			c2.26-17.8,21.67-28.77,24.8-46.42c2.37-13.35-5.81-26.91-16.88-33.98c-11.07-7.07-24.46-8.84-37.41-9.4
			c-12.96-0.55-26.09-0.06-38.71-3.22c-3.33-0.83-6.77-2.03-9.03-4.72c-2.56-3.05-3.1-7.45-2.69-11.49
			c1.1-10.89,25.9-48.31,13.48-60.66c-4.89-4.86-11.53-7.49-18.2-6.82c-6.68,0.67-12.91,3.74-18.76,7.18
			c-12.35,7.28-55.44,55.52-70.95,62.81c-15.24,7.17-32.74,5.06-49.44,4.71c-16.7-0.34-35.26,2.14-46.17,15.39
			c-3.87,4.69-6.53,11.01-5.24,17.05c0.81,3.77,3.07,7.03,5.63,9.81c5.86,6.35,13.5,10.73,19.04,17.38s8.47,17.22,3.25,24.16
			c-2.02,2.69-4.96,4.43-7.84,6.05c-16.11,9.08-34.18,18.4-41.22,36.09c-3.59,9.03-3.52,18.99-0.86,28.37
			c2.83,9.93,12.76,16.88,24.14,16.88h291.24V328.54z" />
                        </g>
                        <path class="st2"
                            d="M445.85,292.37c-7.23-8.19-18.19-11.13-27.91-15.7c-2.68-1.26-5.38-2.74-7.26-5.11
		c-2.61-3.31-3.24-7.93-2.7-12.19c2.26-17.8,21.67-28.77,24.8-46.42c2.37-13.35-5.81-26.91-16.88-33.98
		c-11.07-7.07-24.46-8.84-37.41-9.4c-12.96-0.55-26.09-0.06-38.71-3.22c-3.33-0.83-6.77-2.03-9.03-4.72
		c-2.56-3.05-3.1-7.45-2.69-11.49c1.1-10.89,25.9-48.31,13.48-60.66c-4.25-4.22-9.81-6.76-15.57-6.91
		c7.85,2.13,13.59,6.62,9.41,15.81c-9.65,21.23-99.2,91.87-36.28,98.81c62.92,6.95-41.3,62.92,6.18,66.78
		c36.22,2.94-38.08,45.37-75.23,64.57h196.11c20.11,0,32.28-20.59,20.46-35.25C446.37,292.97,446.11,292.67,445.85,292.37z" />
                        <path class="st1"
                            d="M160.43,141.3c0,0,65.21,22.45,94.21-30.02C283.64,58.8,105.7,121.81,160.43,141.3z" />
                        <path class="st2" d="M240.55,90.88c4.62,3.07,5.54,8.6,0.71,17.34c-20.52,37.12-59.15,36.75-80,33.35
		c7.61,2.37,66.29,18.73,93.38-30.29C262.65,96.78,254.86,91.1,240.55,90.88z" />
                    </g>
                    <path class="st3" d="M137.03,172.75h195.13c3.86,0,6.71,3.6,5.82,7.36l-30.26,127.75H100.08l30.87-130.29
	C131.61,174.74,134.13,172.75,137.03,172.75z" />
                    <path class="st4" d="M133.17,172.75h197.44c2.68,0,4.65,2.5,4.04,5.11l-30.8,130H96.21l30.87-130.29
	C127.75,174.74,130.27,172.75,133.17,172.75z" />
                    <path class="st5"
                        d="M135.08,179.83h188.4l-26.9,118.34H106.97l26.95-117.42C134.05,180.21,134.53,179.83,135.08,179.83z" />
                    <path class="st6"
                        d="M135.21,179.83h188.28l-4.04,17.78H130.06l3.53-16.47C133.75,180.37,134.42,179.83,135.21,179.83z" />
                    <g>
                        <path class="st7" d="M246.15,258.15h-73.98c-1.07,0-1.88-0.95-1.71-2.01l9.44-44.64c0.14-0.84,0.86-1.45,1.71-1.45h73.98
		c1.07,0,1.88,0.95,1.71,2.01l-9.44,44.64C247.72,257.53,247,258.15,246.15,258.15z" />
                        <path class="st7"
                            d="M238.2,298.17h-77.49l7.97-34.26c0.16-0.98,1.01-1.69,2-1.69h73.37c1.26,0,2.21,1.13,2,2.37L238.2,298.17z" />
                        <path class="st7" d="M290.19,258.15h-22.24c-1.07,0-1.88-0.95-1.71-2.01l9.44-44.64c0.14-0.84,0.86-1.45,1.71-1.45h22.24
		c1.07,0,1.88,0.95,1.71,2.01l-9.44,44.64C291.76,257.53,291.04,258.15,290.19,258.15z" />
                        <path class="st7"
                            d="M282.24,298.17H256.5l7.97-34.26c0.16-0.98,1.01-1.69,2-1.69h21.63c1.26,0,2.21,1.13,2,2.37L282.24,298.17z" />
                        <path class="st3" d="M166.72,216.78h-29.94c-1.07,0-1.88-0.95-1.71-2.01l0.79-3.28c0.14-0.84,0.86-1.45,1.71-1.45h29.94
		c1.07,0,1.88,0.95,1.71,2.01l-0.79,3.28C168.29,216.17,167.57,216.78,166.72,216.78z" />
                        <path class="st3" d="M164.52,226.69h-29.95c-1.07,0-1.88-0.95-1.71-2.01l0.79-3.28c0.14-0.84,0.86-1.45,1.71-1.45h29.95
		c1.07,0,1.88,0.95,1.71,2.01l-0.79,3.28C166.09,226.08,165.37,226.69,164.52,226.69z" />
                        <path class="st3" d="M162.32,236.6h-29.95c-1.07,0-1.88-0.95-1.71-2.01l0.79-3.28c0.14-0.84,0.86-1.45,1.71-1.45h29.95
		c1.07,0,1.88,0.95,1.71,2.01l-0.79,3.28C163.89,235.99,163.16,236.6,162.32,236.6z" />
                        <path class="st3" d="M160.11,246.51h-29.95c-1.07,0-1.88-0.95-1.71-2.01l0.79-3.28c0.14-0.84,0.86-1.45,1.71-1.45h29.95
		c1.07,0,1.88,0.95,1.71,2.01l-0.79,3.28C161.69,245.89,160.96,246.51,160.11,246.51z" />
                    </g>
                    <path class="st8" d="M298.29,167.99c0,0-0.36-6.19,1.93-10.49c2.29-4.3,12.51-16.27,12.51-16.27s2.15-0.67,1.75,1.48
	c-0.4,2.15-5.65,10.09-5.65,10.09s3.09,0.03,2.56,1.77c0,0,2.29,0.25,1.75,1.73c0,0,2.96,0.4,2.29,2.02c0,0,3.5-0.4,2.42,2.69
	c-1.08,3.09-3.5,9.55-5.65,10.22s-4.48,1.21-6.01,4.3L298.29,167.99z" />
                    <path class="st5" d="M164.08,136.66l-0.54-0.01c-0.8-0.01-1.44-0.67-1.43-1.47l0.17-11.81c0.01-0.8,0.67-1.44,1.47-1.43l0.54,0.01
	L164.08,136.66z" />
                    <path class="st4" d="M165.97,137.76l-1.59-0.02c-0.35-0.01-0.63-0.29-0.62-0.64l0.23-15.59c0.01-0.35,0.29-0.63,0.64-0.62l1.59,0.02
	L165.97,137.76z" />
                    <path class="st9" d="M82.94,198.66l47.16,29.23c0,0,19.54-8.79,31.92-38.73l0.9,32.1c0,0-18.29,23.85-26.18,24.56
	c-7.89,0.72-37.12-15.42-57.74-37.12L82.94,198.66z" />
                    <path class="st4" d="M201.64,160.28c0,0-28.07,0.88-39.27,17.21c-0.24,0.35-0.36,0.77-0.36,1.19v16.86c0,0.16-0.02,0.32-0.06,0.48
	l-3.82,15.9c-0.08,0.34-0.01,0.7,0.2,0.97l14.31,19.29c0.08,0.11,0.15,0.24,0.18,0.37l8.49,30.43c0.04,0.14,0.06,0.28,0.05,0.42
	l-0.16,10.28c-0.01,0.56,0.41,1.03,0.97,1.08l7.47,0.75c0.35,0.03,0.69-0.02,1-0.17c3.64-1.73,26.62-13.64,29.1-39.22
	c0,0-7.53-24.21-5.2-36.76C216.88,186.82,207.11,159.78,201.64,160.28z" />
                    <path class="st9" d="M178.29,165.57l-6.64,14.23c-0.04,0.09,0.06,0.18,0.14,0.13l7.25-4.4l4.16,6.38c0.06,0.09,0.18,0.1,0.25,0.02
	l18.1-18.5L178.29,165.57z" />
                    <path class="st8" d="M169.91,109.9c0,0-11.03,20.71,0,38.46c0,0,4.84,9.95,12.91,6.72v7.94c0,0.08-0.04,0.15-0.11,0.19l-4.35,2.31
	c-0.06,0.03-0.1,0.1-0.09,0.17l0.8,9.84l22.47-12.04c0.05-0.03,0.05-0.1,0-0.13l-3.79-2.02c-0.08-0.04-0.13-0.12-0.13-0.21
	l0.27-18.41l-1.26-21.34L169.91,109.9z" />
                    <g>
                        <path class="st5" d="M195.03,141.52c0,0-4.35,5.69-11.93,5.61c0,0-0.57,0.88-0.19,1.28c0.38,0.39,10.13-0.67,13.48-6.12
		L195.03,141.52z" />
                        <path class="st4" d="M183.37,147.09c0,0-3-1.28-3.62-1.01c-0.62,0.27-1.46,1.93-1.09,2.22c0.36,0.28,1.52,0.87,4.78,0.19
		C183.45,148.49,183.65,147.04,183.37,147.09z" />
                    </g>
                    <path class="st10" d="M166.37,119.73c0,0-4.8-13.86-7.22-17.63c-2.42-3.77-1.2-8.88,5.86-7.53c7.06,1.35,11.62,4.3,11.62,4.3
	s0,1.08,4.3-0.27c4.3-1.35,25.82-7.26,33.35,4.03c7.53,11.3,4.57,18.56,4.57,18.56s16.94-3.77,15.06,15.6c0,0,6.72,4.3,5.92,12.37
	c-0.8,8.07-9.68,7.53-12.1,7.26c0,0-4.3,11.57-15.6,8.07s-14.57-9.41-14.28-20.17s-7.38-23.03-7.38-23.03s-14.38-0.37-20.56-11.4
	L166.37,119.73z" />
                    <path class="st4" d="M209.52,132.32c-0.38,6.28-5.03,11.11-10.4,10.79c-5.36-0.32-9.41-5.68-9.03-11.96
	c0.26-4.27,2.49-7.87,5.58-9.63c1.46-0.83,3.1-1.26,4.82-1.15C205.86,120.69,209.9,126.04,209.52,132.32z" />
                    <ellipse class="st5" cx="200.93" cy="132.27" rx="8.97" ry="10.44" />
                    <path class="st3" d="M191.96,132.27c0,5.77,4.01,10.44,8.97,10.44c4.83,0,8.75-4.45,8.95-10.01c-5.87-0.04-11.64-1.65-17.07-4.82
	C192.27,129.21,191.96,130.7,191.96,132.27z" />
                    <path class="st4"
                        d="M197.58,119.42h4.07l2.17,1.97l-8.64,0.43C195.17,121.82,196.13,119.5,197.58,119.42z" />
                    <path class="st5" d="M178.58,99.19c0,0,18.29-1.98,19,20.23h3.35c0,0,1.73-23.78-19.05-22.7C181.88,96.72,179.78,96.55,178.58,99.19
	z" />
                    <path class="st11" d="M159.16,207.69l-0.95,3.97c-0.12,0.51-0.01,1.05,0.3,1.47l13.75,18.54c0.34,0.46,0.6,0.99,0.76,1.54l8.37,30
	l-0.16,10.38c-0.01,0.62,0.45,1.14,1.07,1.2l7.17,0.72c0.48,0.05,0.95-0.03,1.39-0.24c2.65-1.29,12.57-6.56,20.1-16.65
	c-2.35-3.58-4.57-7.3-6.67-11.14C193.58,229,180.31,209.69,159.16,207.69z" />
                    <path class="st9" d="M298.29,167.99c0,0-20.8,35.68-38.37,34.61s-47.34-35.5-47.34-35.5s-1.07-1.69-5.28-0.93l7.44,32
	c0,0,24.92,24.52,45,23.8s45.19-33.53,46.44-46.44L298.29,167.99z" />
                    <path class="st8" d="M82.94,198.66c0,0-18.47-11.43-19.28-12.91c-0.81-1.48-2.42-0.94-2.42,0s1.48,4.84,1.48,4.84
	s-15.33-4.42-16.41,1.15c-1.08,5.57,1.08,7.86,5.11,9.74s11.16,6.1,20.84,6.21c9.68,0.11,6.72,1,6.72,1L82.94,198.66z" />
                    <polygon class="st12" points="314.75,218.25 223.48,298.17 296.59,298.17 " />
                    <path class="st3" d="M307.35,317.18H8.97c-0.94,0-1.7-0.76-1.7-1.7v-5.93c0-0.94,0.76-1.7,1.7-1.7h298.38c0.44,0,0.8,0.36,0.8,0.8
	v7.72C308.15,316.82,307.8,317.18,307.35,317.18z" />
                    <path class="st13" d="M307.17,317.18H203.68c-1.53,0-2.77-1.24-2.77-2.77v-3.79c0-1.53,1.24-2.77,2.77-2.77h103.49
	c0.54,0,0.98,0.44,0.98,0.98v7.36C308.15,316.74,307.72,317.18,307.17,317.18z" />
                    <ellipse class="st4" cx="217.29" cy="312.52" rx="2.37" ry="2.2" />
                </svg>
            </div>
        </div>

        <div class="faq-wrapper tw-flex tw-mb-20"
            v-if="active_support_tab === 'faq' && categories_loaded && questions_loaded">
            <div class="faq-categories tw-flex tw-flex-1 tw-flex-col">
                <div class="category-title tw-flex secondary-c tw-mb-6">
                    <i class="far fa-map-signs tw-pr-4"></i>
                    <h2 v-text="translations['support.faq_categories']"></h2>
                </div>
                <h4 class="normal-text tw-leading-relaxed tw-mb-4 tw-pl-8 tw-cursor-pointer tw-select-none hover:tw-opacity-75"
                    v-for="category in categories" :key="category.id" v-text="category.name"
                    :class="{ 'active': category.id === active_faq_category.id }"
                    @click="setActiveCategoryTo(category)">
                </h4>
            </div>

            <div class="questions tw-flex-2 tw-ml-16" v-if="active_faq_category">
                <div class="tw-flex tw-flex-col tw-bg-white tw-shadow tw-p-6 tw-pb-3 tw-rounded">
                    <div class="tw-flex tw-items-center tw-mb-6 secondary-c tw-font-semibold">
                        <i class="far fa-question tw-mr-3 tw-pt-px"></i>
                        <h4 v-text="active_faq_category.name"></h4>
                    </div>
                    <template v-if="active_questions">
                        <smooth-reflow :options="{ property: 'height', transition: 'height .2s' }">
                            <div class="tw-py-2 tw-border-blue-0 tw-border-t" v-for="question in active_questions"
                                :key="question.id">
                                <div class="question normal-text tw-cursor-pointer tw-rounded tw-px-4 tw-py-4 tw-text-sm tw-select-none hover:tw-bg-blue-0"
                                    @click="toggleExpand(question)">
                                    <div class="tw-flex tw-justify-between">
                                        <h5 class="tw-leading-relaxed tw-font-semibold" v-text="question.question"></h5>
                                        <i class="fal tw-pt-px tw-mt-px tw-text-lg"
                                            :class="question.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
                                    </div>
                                    <p class="tw-mt-2 tw-leading-relaxed" v-html="question.answer"
                                        v-if="question.expanded"></p>
                                </div>
                            </div>
                        </smooth-reflow>
                    </template>
                </div>
            </div>
        </div>

        <div class="helpdesk-wrapper tw-mb-20" v-if="active_support_tab === 'helpdesk' && helpdesk_available">
            <div class="page-navigation-functions flex flex-full-width flex-align-start device-hidden">
                <helpdeskfilter></helpdeskfilter>
            </div>

            <p class="light-text tw-mb-4" v-if="helpdesk_board.description && helpdesk_board.description !== ''">
                <i class="far fa-info-circle tw-mr-1"></i>
                {{ helpdesk_board.description }}
            </p>

            <newpost polls_installed="false" :is_helpdesk_prop="true" :board_id_prop="helpdesk_board.id"></newpost>

            <feed :board-id-prop="helpdesk.id" :is-helpdesk-prop="true"></feed>
        </div>

        <div class="contact-wrapper tw-mb-20 tw-flex tw-items-start"
            v-if="active_support_tab === 'contact' && contact_available">
            <div class="contact-form tw-bg-white tw-shadow tw-p-6 tw-rounded normal-text">
                <template v-if="!user">
                    <p class="tw-font-semibold tw-pb-3" v-text="translations['fields.email']"></p>
                    <input v-model="email_address" type="text" autocomplete="off">
                </template>

                <p class="tw-font-semibold tw-pb-3" v-text="translations['mailings.subject']"></p>
                <input v-model="email_subject" type="text" autocomplete="off"
                    :placeholder="translations['support.email_subject_placeholder']">

                <p class="tw-font-semibold tw-pb-3 tw-mt-6" v-text="translations['support.ask_your_question']"></p>
                <textarea v-model="email_content" rows="6" type="text" autocomplete="off"
                    :placeholder="translations['support.email_content_placeholder']"></textarea>

                <!--<div class="g-recaptcha m-b" v-if="settings.recaptcha !== ''" :data-sitekey="settings.recaptcha"></div>-->

                <div class="general-button tw-mt-4 tw-relative" @click="submitTicket">
                    {{ translations['messages.send'] }}
                    <div class="sending-spinner" v-if="sending_email"></div>
                </div>

                <template v-if="success_message && !error_message">
                    <p class="tw-text-green-600 tw-font-semibold tw-mt-3 tw-text-sm" v-text="success_message"></p>
                </template>
                <template v-else-if="error_message">
                    <p class="tw-text-red-600 tw-font-semibold tw-mt-3 tw-text-sm" v-text="error_message"></p>
                </template>
            </div>

            <div class="contact-info tw-flex-2 tw-ml-16">
                <div class="tw-bg-white tw-shadow tw-p-6 tw-rounded">
                    <div class="tw-mb-4 normal-text">
                        <div class="tw-flex tw-items-center tw-font-semibold tw-mb-2">
                            <i class="far fa-building tw-pr-2"></i>
                            <p>{{ translations['fields.company_info'] }}</p>
                        </div>
                        <p>
                            {{ settings.company }}
                            <br />
                            {{ settings.address }}
                            <br />
                            {{ settings.zipcode }} {{ settings.city }}
                        </p>
                    </div>
                    <div class="tw-mb-4 normal-text" v-if="settings.vat !== ''">
                        <div class="tw-flex tw-items-center tw-font-semibold tw-mb-2">
                            <i class="far fa-certificate tw-pr-2"></i>
                            <p>{{ translations['fields.vat'] }}</p>
                        </div>
                        <p v-text="settings.vat"></p>
                    </div>
                    <div class="tw-mb-4 normal-text" v-if="settings.kvk !== ''">
                        <div class="tw-flex tw-items-center tw-font-semibold tw-mb-2">
                            <i class="far fa-briefcase tw-pr-2"></i>
                            <p>KvK</p>
                        </div>
                        <p v-text="settings.kvk"></p>
                    </div>
                    <div class="tw-mb-4 normal-text" v-if="settings.iban !== ''">
                        <div class="tw-flex tw-items-center tw-font-semibold tw-mb-2">
                            <i class="far fa-money-check tw-pr-2"></i>
                            <p>{{ translations['fields.iban'] }}</p>
                        </div>
                        <p v-text="settings.iban"></p>
                    </div>
                    <div class="tw-mb-4 normal-text" v-if="settings.email !== ''">
                        <div class="tw-flex tw-items-center tw-font-semibold tw-mb-2">
                            <i class="far fa-at tw-pr-2"></i>
                            <p>{{ translations['fields.email'] }}</p>
                        </div>
                        <p v-text="settings.email"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Global from '../../mixins/Global';

export default {
    name: 'SupportIndex',

    mixins: [Global],

    props: {
        helpdesk: {
            default: false,
        },
        can_contact: {
            default: false,
        },
    },

    data() {
        return {
            active_support_tab: 'faq',
            categories: [],
            questions: [],
            categories_loaded: false,
            questions_loaded: false,
            active_faq_category: false,
            helpdesk_board: false,
            sending_email: false,
            email_address: '',
            email_subject: '',
            email_content: '',
            success_message: '',
            error_message: false,
            board_x: 4
        };
    },

    computed: {
        ...mapState([
            'plugins',
        ]),

        active_questions() {
            const questions = this.questions.filter(question => (question.faq_category_id === this.active_faq_category.id));

            if (questions.length > 0) {
                return questions;
            }

            return false;
        },

        helpdesk_available() {
            return this.helpdesk_board !== false && this.settings['support.helpdesk'] && this.settings['support.helpdesk'] !== '0' && (this.plugins.community || this.settings['menu_boards'] !== '');
        },

        contact_available() {
            return this.settings['support.contact'] && this.settings['support.contact'] !== '0' && this.can_contact;
        },

        faq_available() {
            return this.categories.length > 0;
        },

        support_options_count() {
            let count = 0;

            if (this.helpdesk_available) {
                count += 1;
            }

            if (this.contact_available) {
                count += 1;
            }

            if (this.faq_available) {
                count += 1;
            }

            return count;
        },

        support_not_enabled() {
            return (!this.settings['support.helpdesk'] || this.settings['support.helpdesk'] && this.settings['support.helpdesk'] === '0') && (!this.settings['support.contact'] || this.settings['support.contact'] && this.settings['support.contact'] === '0') && !this.faq_available;
        }
    },

    methods: {
        setTabTo(name) {
            this.active_support_tab = name;

            const url_params = new URLSearchParams(window.location.search);

            url_params.set('tab', name);

            window.history.replaceState({}, '', `${location.pathname}?${url_params}`);
        },

        setActiveCategoryTo(category) {
            this.active_faq_category = category;

            window.location.hash = category.name;
        },

        toggleExpand(question) {
            question.expanded = !question.expanded;
        },

        submitTicket() {
            this.sending_email = true;

            const data = {
                title: this.email_subject,
                content: this.email_content,
                email: this.user ? this.user.email : this.email_address,
            };

            axios.post('/contact', data).then((response) => {
                this.sending_email = false;

                if (response.status === 200) {
                    this.email_subject = '';
                    this.email_content = '';
                    this.email_address = '';
                    this.success_message = response.data.message;
                    this.error_message = '';
                }
            }).catch(() => {
                this.sending_email = false;
                this.success_message = '';
                this.error_message = this.translations['support.email_not_send'];
            });
        },

        // we have to wait for the settings before we can mount, so we create our own mount method which fires later
        mount() {
            const url_params = new URLSearchParams(window.location.search);

            if (url_params.has('tab')) {
                this.active_support_tab = url_params.get('tab');
            }

            let hash = window.location.hash;

            axios.get('/api/v3/faq-categories').then((result) => {
                this.categories = result.data.data;

                if (this.faq_available) {
                    if (hash !== '') {
                        hash = hash.substr(1);
                        hash = decodeURI(hash);

                        const hash_category = this.categories.find(category => category.name === hash);

                        if (hash_category) {
                            this.active_faq_category = hash_category;
                        }
                    } else {
                        this.active_faq_category = this.categories[0];
                    }
                } else if (this.active_support_tab === 'faq') {
                    if (this.settings['support.helpdesk'] && this.settings['support.helpdesk'] !== '0' && this.helpdesk) {
                        this.setTabTo('helpdesk');
                    } else {
                        this.setTabTo('contact');
                    }
                } else if (this.active_support_tab === 'helpdesk') {
                    if (!this.settings['support.helpdesk'] || (this.settings['support.helpdesk'] && this.settings['support.helpdesk'] === '0') && !this.helpdesk) {
                        if (this.contact_available) {
                            this.setTabTo('contact');
                        }
                    }
                } else if (this.active_support_tab === 'helpdesk') {
                    if (!this.settings['support.helpdesk'] || (this.settings['support.helpdesk'] && this.settings['support.helpdesk'] === '0') && !this.helpdesk) {
                        if (this.contact_available) {
                            this.setTabTo('contact');
                        }
                    }
                }

                this.categories_loaded = true;
            }).catch(() => {
                this.categories_loaded = true;
            });

            axios.get('/api/v3/faqs').then((result) => {
                for (let i = 0; i < result.data.data.length; i += 1) {
                    result.data.data[i].expanded = false;
                }

                this.questions = result.data.data;

                this.questions_loaded = true;
            });
        },
    },

    mounted() {
        if (this.helpdesk !== false) {
            this.helpdesk_board = JSON.parse(this.helpdesk);
        }
    },

    watch: {
        settings(load) {
            if (load !== false) {
                this.mount();
            }
        },
    },
};
</script>